import BaseApiService from '@/services/common/api/baseApiService';

class UsersService extends BaseApiService {
  getSuppliers(pagination) {
    const paginationData = pagination || {};
    return this.makeRequest(this.httpClient.get(this.apiRoutes.suppliers, {
      params: {
        pageSize: paginationData.pageSize,
        pageNumber: paginationData.pageNumber,
        sortBy: paginationData.sortBy,
        sortOrder: paginationData.sortOrder,
        filterQuery: paginationData.filterQuery,
      },
    }));
  }

  addSupplier(newSupplier) {
    return this.makeRequest(this.httpClient.post(this.apiRoutes.suppliers, newSupplier));
  }

  updateSupplier(supplier) {
    return this.makeRequest(
      this.httpClient.put(
        this.apiEndPointsBuilder.updateSupplier(supplier.id),
        supplier,
      ),
    );
  }

  getEmployees(pagination) {
    const paginationData = pagination || {};
    return this.makeRequest(this.httpClient.get(this.apiRoutes.employees, {
      params: {
        pageSize: paginationData.pageSize,
        pageNumber: paginationData.pageNumber,
        sortBy: paginationData.sortBy,
        sortOrder: paginationData.sortOrder,
        filterQuery: paginationData.filterQuery,
      },
    }));
  }

  addEmployee(newEmployee) {
    return this.makeRequest(this.httpClient.post(this.apiRoutes.employees, newEmployee));
  }

  updateEmployee(employee) {
    return this.makeRequest(
      this.httpClient.put(
        this.apiEndPointsBuilder.updateEmployee(employee.id),
        employee,
      ),
    );
  }

  getManagers() {
    return this.makeRequest(this.httpClient.get(this.apiRoutes.managers));
  }

  resendSupplierEmailVerification(supplier) {
    return this.makeRequest(this.httpClient
      .post(this.apiEndPointsBuilder.resendSupplierEmailVerification(supplier.id), supplier));
  }

  resendEmployeeEmailVerification(employee) {
    return this.makeRequest(this.httpClient
      .post(this.apiEndPointsBuilder.resendEmployeeEmailVerification(employee.id), employee));
  }
}

export default UsersService;
